import type { RiskMatrixItem } from "@/mocks/configuracoes";

interface RiskMatrixPanelProps {
  matrix: RiskMatrixItem[];
}

const classBadge: Record<string, { bg: string; text: string; label: string }> = {
  "baixo": { bg: "bg-primary-100 border-primary-300", text: "text-primary-800", label: "Baixo" },
  "médio": { bg: "bg-caution-100 border-caution-300", text: "text-caution-800", label: "Médio" },
  "alto": { bg: "bg-warning-100 border-warning-300", text: "text-warning-800", label: "Alto" },
  "crítico": { bg: "bg-danger-100 border-danger-300", text: "text-danger-800", label: "Crítico" },
};

export default function RiskMatrixPanel({ matrix }: RiskMatrixPanelProps) {
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-xl border border-background-200/70 p-5">
        <h3 className="text-sm font-semibold text-foreground-900 mb-1">Matriz de Risco</h3>
        <p className="text-xs text-foreground-500 mb-4">Probabilidade × Consequência determinam a classe de risco e ação recomendada</p>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Probabilidade</th>
                <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Consequência</th>
                <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Classe resultante</th>
                <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Descrição</th>
                <th className="text-left py-3 px-3 text-xs font-medium text-foreground-500">Ação recomendada</th>
              </tr>
            </thead>
            <tbody>
              {matrix.map((m) => {
                const b = classBadge[m.resultingClass];
                return (
                  <tr key={m.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                    <td className="py-2.5 px-3 text-foreground-700">{m.probability}</td>
                    <td className="py-2.5 px-3 text-foreground-700">{m.consequence}</td>
                    <td className="py-2.5 px-3">
                      <span className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-semibold border ${b.bg} ${b.text}`}>{b.label}</span>
                    </td>
                    <td className="py-2.5 px-3 text-foreground-600 text-xs max-w-[200px]">{m.description}</td>
                    <td className="py-2.5 px-3 text-foreground-600 text-xs max-w-[220px]">{m.recommendedAction}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}